import { render, staticRenderFns } from "./PurchasesSimulator.vue?vue&type=template&id=6a7e4cc0"
import script from "./PurchasesSimulator.vue?vue&type=script&lang=js"
export * from "./PurchasesSimulator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports